var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2784 0.90625H0.640625V5.0379H17.2784V0.90625Z",
    fill: "#F89C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2784 18.7734H0.640625V22.9051H17.2784V18.7734Z",
    fill: "#F89C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2784 9.84375H0.640625V13.9754H17.2784V9.84375Z",
    fill: "#F89C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logo-sm.468782f403593ac0f5120ec10297aba6.svg";
export { ForwardRef as ReactComponent };